import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import moment from "moment";
import store from "./store";

Vue.component("AlertSnackBar", () => import("./components/SnackMsj"));

Vue.config.productionTip = false;
moment.locale("es");
Vue.prototype.moment = moment;
// moment.locale('es')

new Vue({
  router,
  vuetify,
  moment,
  store,
  render: (h) => h(App),
  created() {
    this.checkSession();
  },
  methods: {
    checkSession() {
      if (this.$store.getters.usuario.user_name != null) {
        this.$router.push("/Principal");
      }
    },
  },
}).$mount("#app");
